<template>
  <div class="flex flex-items justify-center leading-none align-center">
    <div>
      <h3 class="text-chplus-xl">
        {{ String(days).padStart(2, "0") }}
      </h3>
      <p class="text-chplus-countdown uppercase">
        {{ $t("views.home.days") }}
      </p>
    </div>
    <div>
      <h3 class="text-chplus-xl px-2">:</h3>
    </div>
    <div>
      <h3 class="text-chplus-xl">
        {{ String(hours).padStart(2, "0") }}
      </h3>
      <p class="text-chplus-countdown uppercase">
        {{ $t("views.home.hours") }}
      </p>
    </div>
    <div>
      <h3 class="text-chplus-xl px-2">:</h3>
    </div>
    <div>
      <h3 class="text-chplus-xl">
        {{ String(minutes).padStart(2, "0") }}
      </h3>
      <p class="text-chplus-countdown uppercase">
        {{ $t("views.home.minutes") }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Countdown",
  data() {
    return {
      now: new Date(),
      interval: 0,
      ended: false
    };
  },
  props: {
    end: {
      type: Date,
      required: true
    }
  },
  mounted() {
    this.interval = setInterval(() => {
      this.now = new Date();

      if (!this.ended && this.now >= this.end) {
        this.ended = true;
        this.$emit("ended");
      }
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  computed: {
    timeDifferenceMs() {
      return Math.max(new Date(this.end) - this.now, 0);
    },
    days() {
      return Math.floor(this.timeDifferenceMs / 1000 / 60 / 60 / 24);
    },
    hours() {
      return Math.floor(this.timeDifferenceMs / 1000 / 60 / 60) % 24;
    },
    minutes() {
      return Math.floor(this.timeDifferenceMs / 1000 / 60) % 60;
    }
  }
};
</script>
